(function () {
  "use strict";

  var html = document.documentElement;
  var body = document.body;

  /* —— Drawer scroll unlock / currency (needs drawer) —— */
  var drawer = document.querySelector("[data-drawer-menu]");
  if (drawer) {
    var lastOpen = false;

    function unlockScroll() {
      body.classList.remove("scroll-lock");
      html.classList.remove("scroll-lock");
      body.style.top = "";
      body.style.position = "";
      body.style.width = "";
      body.style.overflow = "";
      html.style.overflow = "";
    }

    function isOpen() {
      return drawer.classList.contains("visible") || drawer.classList.contains("active");
    }

    function setOpen(open) {
      if (open === lastOpen) return;
      lastOpen = open;
      html.classList.toggle("pf-drawer-open", open);
      body.classList.toggle("pf-drawer-open", open);
      if (open) unlockScroll();
    }

    function closeDrawer() {
      if (!isOpen()) return;
      drawer.classList.remove("visible", "active");
      setOpen(false);
      unlockScroll();
    }

    new MutationObserver(function () {
      setOpen(isOpen());
      if (lastOpen) unlockScroll();
    }).observe(drawer, { attributes: true, attributeFilter: ["class"] });

    document.addEventListener(
      "click",
      function (evt) {
        var onLogo = evt.target.closest(
          ".header__logo-wrapper, .header__logo-image, .header__logo-text--pf-archive, .header__logo-text"
        );
        var onHamburger = evt.target.closest("#mobile-nav, .mobile-nav__trigger");
        var onOverlay = evt.target.closest("[data-drawer-menu] [data-overlay]");

        if (onLogo && isOpen()) {
          evt.preventDefault();
          evt.stopPropagation();
          closeDrawer();
          return;
        }

        if (onHamburger) {
          ensureCurrencySelect();
          return;
        }

        if (onOverlay && isOpen()) closeDrawer();
      },
      true
    );

    function getCountryOptions() {
      var options = [];
      var nodes = document.querySelectorAll(".footer [data-disclosure-option]");
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el.dataset.value) continue;
        options.push({ value: el.dataset.value, text: el.textContent.trim() });
      }
      return options;
    }

    function ensureCurrencySelect() {
      if (drawer.querySelector("#pf-drawer-country-code")) return;

      var footer = drawer.querySelector("[data-footer]");
      var options = getCountryOptions();
      if (!footer || !options.length) return;

      var current =
        (document.querySelector('.footer [name="country_code"]') || {}).value ||
        (document.querySelector(".footer [data-disclosure-input]") || {}).value ||
        "";

      var returnTo = window.location.pathname + window.location.search;
      footer.innerHTML =
        '<li class="drawer-menu__item drawer-menu__item--localization" data-list-item>' +
        '<form method="post" action="/localization" id="DrawerLocalizationForm" class="selectors-form pf-drawer-localization" data-scroll-lock-ignore>' +
        '<input type="hidden" name="form_type" value="localization">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="_method" value="put">' +
        '<input type="hidden" name="return_to" value="' +
        returnTo +
        '">' +
        '<select id="pf-drawer-country-code" name="country_code" class="pf-drawer-currency__select" aria-label="Currency" data-scroll-lock-ignore></select>' +
        "</form></li>";

      var select = footer.querySelector("#pf-drawer-country-code");
      for (var j = 0; j < options.length; j++) {
        var option = document.createElement("option");
        option.value = options[j].value;
        option.textContent = options[j].text;
        if (options[j].value === current) option.selected = true;
        select.appendChild(option);
      }

      select.addEventListener("change", function () {
        if (select.form) select.form.submit();
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", ensureCurrencySelect);
    } else {
      ensureCurrencySelect();
    }
  }

  /* Pause off-screen homepage videos */
  var videos = document.querySelectorAll(".pf-home-video__media");
  if (videos.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === "none") video.preload = "metadata";
            if (video.paused) video.play().catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        }
      },
      { rootMargin: "100px 0px", threshold: 0 }
    );
    for (var v = 0; v < videos.length; v++) io.observe(videos[v]);
  }

  /* Strip leftover sticky classes (theme sticky loop is disabled for drop-coor) */
  function clearStickyResidue() {
    if (!body.classList.contains("drop-coor-theme")) return;
    html.classList.remove("header-stuck", "header-sticky", "sticky-header-enabled");
    var sticky = document.querySelectorAll(".header-container.is-sticky");
    for (var i = 0; i < sticky.length; i++) {
      sticky[i].classList.remove("is-sticky");
      sticky[i].style.top = "";
    }
  }
  clearStickyResidue();
  window.addEventListener("load", clearStickyResidue);

  /* Hover second image — desktop only, load on first hover of that card */
  function enableHoverImages() {
    if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      return;
    }

    function inject(el) {
      if (!el || el.querySelector("img") || !el.getAttribute("data-src")) return;
      var img = document.createElement("img");
      img.className = "image__img";
      img.src = el.getAttribute("data-src");
      img.srcset = el.getAttribute("data-srcset") || "";
      img.sizes = el.getAttribute("data-sizes") || "50vw";
      img.alt = el.getAttribute("data-alt") || "";
      img.loading = "lazy";
      img.decoding = "async";
      el.appendChild(img);
      el.hidden = false;
    }

    document.addEventListener(
      "pointerenter",
      function (evt) {
        var card = evt.target.closest && evt.target.closest(".product-item");
        if (!card) return;
        inject(card.querySelector("[data-pf-hover-image]"));
      },
      true
    );
  }
  enableHoverImages();

  /* Idle: decode a few below-fold images so first scroll feels ready */
  function warmImages() {
    if (!("requestIdleCallback" in window)) return;
    window.requestIdleCallback(
      function () {
        var imgs = document.querySelectorAll(
          ".product-item .product-item__image.first img, .product-item .product-item__image:not(.not-first) img"
        );
        for (var i = 0; i < Math.min(imgs.length, 8); i++) {
          try {
            if (imgs[i].decode) imgs[i].decode().catch(function () {});
          } catch (e) {}
        }
      },
      { timeout: 2500 }
    );
  }
  if (document.readyState === "complete") warmImages();
  else window.addEventListener("load", warmImages);
})();
